export const state = {
  isOpen: false,
  hasAnimated: false,
};
